import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudAccordionModule,
	FreudAvatarModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { FreudCheckboxModule } from '@freud-ds/web-components';
import { FreudButtonModule } from '@freud-ds/web-components';
import { FreudDialogModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { PromptuaryQualityDescriptionModule } from '../promptuary-quality-description/promptuary-quality-description.module';
import { PromptuaryQualityModal } from './promptuary-quality-modal.component';

@NgModule({
	declarations: [PromptuaryQualityModal],
	exports: [PromptuaryQualityModal],
	providers: [],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FormsModule,
		FreudTypographyModule,
		FreudAvatarModule,
		FreudAccordionModule,
		FreudCheckboxModule,
		FreudButtonModule,
		FreudDialogModule,
		PromptuaryQualityDescriptionModule,
	],
})
export class PromptuaryQualityModalModule {}
